const MAX_QR_PAYLOAD_LENGTH = 2048;

const safeDecodeURIComponent = (value) => {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};

const normalizeBatchCode = (value) => {
    const batchCode = String(value || '').trim();
    if (!batchCode || batchCode.length > 255 || !/^[A-Za-z0-9][A-Za-z0-9._/ -]*$/.test(batchCode)) {
        return null;
    }
    return batchCode;
};

const batchCodeFromObject = (value) => {
    if (!value || typeof value !== 'object') return null;
    return normalizeBatchCode(value.batchCode || value.batchId);
};

const batchCodeFromUrl = (payload) => {
    try {
        const url = new URL(payload);
        const queryBatchCode = url.searchParams.get('batchCode') || url.searchParams.get('batchId');
        if (queryBatchCode) return normalizeBatchCode(queryBatchCode);

        const match = url.pathname.match(/\/(?:traceability|traceability-result)\/(.+)$/i);
        return match ? normalizeBatchCode(safeDecodeURIComponent(match[1])) : null;
    } catch (error) {
        return null;
    }
};

const batchCodeFromJson = (payload) => {
    try {
        return batchCodeFromObject(JSON.parse(payload));
    } catch (error) {
        return null;
    }
};

const batchCodeFromBase64Json = (payload) => {
    try {
        return batchCodeFromJson(atob(payload));
    } catch (error) {
        return null;
    }
};

export const extractBatchCodeFromQrPayload = (payload) => {
    const normalizedPayload = String(payload || '').trim();
    if (!normalizedPayload || normalizedPayload.length > MAX_QR_PAYLOAD_LENGTH) return null;

    return batchCodeFromUrl(normalizedPayload)
        || batchCodeFromJson(normalizedPayload)
        || batchCodeFromBase64Json(normalizedPayload)
        || normalizeBatchCode(normalizedPayload);
};

export const buildTraceabilityPath = (batchCode) => {
    const normalizedBatchCode = normalizeBatchCode(batchCode);
    return normalizedBatchCode ? `/traceability/${encodeURIComponent(normalizedBatchCode)}` : null;
};
